<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div class="flex">
				<div class="w-full" v-if="!isLoading">
					<div class="flex w-full">
						<div class="main w-full">
							<BaseInput ref="company" :label="$t('company')" v-model="model.company" />

							<PersonNameForm ref="PersonNameForm" v-model="model" :show-company="false" />
							<div class="flex space-x-4">
								<BaseInput
									ref="BaseInput.model.street"
									class="w-full md:w-1/2 pr-0"
									:label="$t('street')"
									type="text"
									v-model="model.street"
									:required="true"
								/>

								<BaseInput
									ref="BaseInput.model.houseNumber"
									class="w-full md:w-1/2"
									:label="$t('number')"
									type="text"
									v-model="model.houseNumber"
									:required="false"
								/>
							</div>

							<CityInput :required="true" ref="cityinput" v-model="model.city" />

							<div class="flex space-x-4">
								<BaseInput ref="BaseInput.model.phone" :required="true" class="w-full" :label="$t('phone')" v-model="model.phone" type="text" />
								<BaseInput :required="true" ref="BaseInput.model.email" class="w-full" :label="$t('e_mail')" v-model="model.email" type="text" />
							</div>
						</div>
					</div>
				</div>
				<LoadingSpinner v-else />
			</div>
		</div>
	</div>
</template>

<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Authentication from '@/mixins/Authentication';
import ApplyDamageAssessor from '@/views/management/RepairShop/ApplyDamageAssessor.vue';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import PersonNameForm from '@/components/forms/PersonNameForm.vue';
import CityInput from '@/components/forms/CityInput.vue';
import Validate from '@/mixins/Validate';

export default {
	components: { CityInput, PersonNameForm, BaseInput, LoadingSpinner },
	name: 'OnboardingServiceProviderDamageAssessor',
	mixins: [Validate, Authentication],
	data() {
		return {
			isLoading: false,
			model: {
				city: {},
			},
		};
	},
	methods: {
		getData() {
			return this.model;
		},
		clearForm() {
			this.model = { city: {} };
		},
	},
};
</script>
